export const LOGIN_APP_DISPLAY_NAME = {
    FACEBOOK: 'Facebook',
    GOOGLE: 'Google+',
    APPLE: 'Apple',
} as const;

export const LOGIN_PLATFORM = {
    FACEBOOK: 'facebook',
    GOOGLE: 'googleplus',
    APPLE: 'apple',
} as const;
